import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import api from '../../../../api/api'
import { ZoomFrame } from '@/components/ui/zoomable-image'

import { getAssetLink } from '../../../../helpers/get-asset-link'
import { rewardsHistoryColumns } from '../helpers'
import { useSnackbar } from '../../../../helpers/hooks/useSnackbar'
import ModalContainer from '../../../ModalContainer/ModelContainer'
import TextCell from '../components/TextCell/TextCell'
import FeaturedTable from '../../../FeaturedTable/FeaturedTable'
import Icon from '../../../Icons'

const RewardsHistoryModal = ({ onClose = () => {}, client, building }) => {
  const { t } = useTranslation(['rewards-loyalty'])
  const [isLoading, setIsLoading] = useState(true)
  const [history, setHistory] = useState([])
  const { timezone } = building
  const { displaySnackbar } = useSnackbar()

  const fetchRewardHistory = async () => {
    try {
      const { data } = await api.fetchClientRewards(client.id)
      setHistory(data)
    } catch ({ message }) {
      displaySnackbar(message, true)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (client.id) {
      fetchRewardHistory()
    }
  }, [client])

  return (
    <ModalContainer
      additionalClass={'rewards-modal'}
      onClose={onClose}
      headerTitle={t('rewards-loyalty:rewardsHistoryModal.headerTitle')}
      headerIcon={<Icon icon="cup" />}
    >
      <div
        className={`rewards-modal-content rewards-base-view rewards-history ${
          isLoading ? 'is-loading' : ''
        }`}
      >
        <div className="rewards-history-head">
          <ZoomFrame
            className="zoom-avatar-frame"
            hintSize="2rem"
            src={getAssetLink({ path: 'chitown-avatar/avatar', file: client.avatar })}
            title={client.name}
          >
            <img src={getAssetLink({ path: 'chitown-avatar/avatar', file: client.avatar })} />
          </ZoomFrame>
          <TextCell title={client.name} text={client.email} />
        </div>
        {!isLoading && (
          <div className="rewards-table" style={{ padding: 0 }}>
            <div className={`ctp-rewards-history-list`}>
              <FeaturedTable columns={rewardsHistoryColumns({ timezone, t })} data={history} />
            </div>
          </div>
        )}
      </div>
    </ModalContainer>
  )
}

RewardsHistoryModal.propTypes = {
  onClose: PropTypes.func,
  client: PropTypes.object,
  building: PropTypes.object,
}

export default RewardsHistoryModal
